import { COLOR_OPTIONS } from 'config/style';

export const RISK_MAP_CLUSTER_BASE_SIZE = 40;
export const RISK_MAP_CLUSTER_HOVER_SIZE = 44;
export const RISK_MAP_CLUSTER_OUTER_BACKDROP_RADIUS = 20;
export const RISK_MAP_CLUSTER_RING_OUTER_RADIUS = 18;
export const RISK_MAP_CLUSTER_RING_INNER_RADIUS = 14;
export const RISK_MAP_CLUSTER_HOVER_HALO_OUTER_RADIUS = 22;
export const RISK_MAP_CLUSTER_SEGMENT_GAP_DEGREES = 4;

export const RISK_MAP_CLUSTER_FONT_SIZE = 14;
export const RISK_MAP_CLUSTER_FONT_WEIGHT = 600;
export const RISK_MAP_CLUSTER_LETTER_SPACING = -0.75;

export const RISK_MAP_CLUSTER_TEXT_COLOR = COLOR_OPTIONS.NEUTRAL_100;
export const RISK_MAP_CLUSTER_INNER_FILL = COLOR_OPTIONS.WHITE;
export const RISK_MAP_CLUSTER_OUTER_BACKDROP_FILL = COLOR_OPTIONS.WHITE;
export const RISK_MAP_CLUSTER_HOVER_HALO_FILL = COLOR_OPTIONS.WHITE;
export const RISK_MAP_CLUSTER_HOVER_HALO_OPACITY = 0.4;

export type RiskMapClusterBucket = 'high' | 'medium' | 'low' | 'noRisk' | 'notApplicable';

export type RiskMapClusterColors = Record<RiskMapClusterBucket, string>;

export const RISK_MAP_CLUSTER_DEFAULT_COLORS: RiskMapClusterColors = {
  high: COLOR_OPTIONS.RED_60,
  medium: COLOR_OPTIONS.ORANGE_30,
  low: COLOR_OPTIONS.GREEN_50,
  noRisk: COLOR_OPTIONS.NEUTRAL_30,
  notApplicable: COLOR_OPTIONS.NEUTRAL_50
};

export const RISK_MAP_CLUSTER_SEGMENT_ORDER: RiskMapClusterBucket[] = ['high', 'medium', 'low', 'noRisk', 'notApplicable'];
